import { useEffect, useState } from "react";
import { useAuth } from "../../../services/Security/auth";
import SessionIdService from "../../../services/session/sessionIdService";

const SecurityLogoutPage = () => {
	const auth = useAuth();
	const [sessionIdMismatch, setSessionIdMismatch] = useState(false);
	const urlSearchParams = new URLSearchParams(window.location.search);
	const externalSessionId = urlSearchParams.get("session_id");
	const refUrl = urlSearchParams.get("reference_url");

	useEffect(() => {
		checkSession();
	}, []);

	const checkSession = async () => {
		if (!SessionIdService.get() || !externalSessionId || externalSessionId === SessionIdService.get()) {
			await auth.logout(true);
			if (refUrl !== null) {
				window.location.href = refUrl;
			}
		} else if (SessionIdService.get() && SessionIdService.get() !== externalSessionId) {
			setSessionIdMismatch(true);
		}
	};

	useEffect(() => {
		if (sessionIdMismatch) {
			if (refUrl) {
				window.location.href = refUrl;
			}
		}
	}, [sessionIdMismatch]);

	return <></>;
};

export default SecurityLogoutPage;
